import { Disposable } from "../../../base/common/lifecycle";
import { safeStringify } from "../../../base/common/objects.js";
import { IAnalyticsService } from "./analytics";



export function analyticsErrorDetails(error: unknown) {
    const value = error && typeof error === "object" ? error as { name?: unknown; message?: unknown; stack?: unknown } : undefined;
    return {
        name: typeof value?.name === "string" ? value.name : "Error",
        message: (typeof value?.message === "string" ? value.message : typeof error === "string" ? error : safeStringify(error) ?? "Unknown error").slice(0, 500),
        stack: typeof value?.stack === "string" ? value.stack.slice(0, 2000) : undefined,
        timestamp: Date.now(),
    };
}

export abstract class BaseAnalyticsService extends Disposable implements IAnalyticsService {

    async initialize(): Promise<void> {
        // Override in subclasses if needed
    }

    logError(error: unknown, context?: Record<string, unknown>): void {
        const { name, ...details } = analyticsErrorDetails(error);
        this.onLogEvent(name, { ...context, ...details, error_name: name });
    }

    logEvent(eventName: string, params?: { [key: string]: any; }): void {
        this.onLogEvent(eventName, params);
    }

    protected abstract onLogEvent(eventName: string, params?: { [key: string]: any; }): void;
}